var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyEos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9961 4.99951L9.76718 10.8188L7.99609 19.4212L13.9961 23.0718L19.9961 19.4212L18.1889 10.7826L13.9961 4.99951ZM8.972 19.0236L10.3093 12.4814L13.3455 21.6983L8.972 19.0236ZM10.7431 10.9995L13.9961 6.51758L17.2491 10.9995L13.9961 20.8308L10.7431 10.9995ZM14.6106 21.6983L17.6467 12.4814L18.984 19.0236L14.6106 21.6983Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 18.0723,
    fill: "white",
    transform: "translate(8 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyEos);
export default __webpack_public_path__ + "static/media/Currency=EOS.551e5afb6d978b76c3268fd4294043ed.svg";
export { ForwardRef as ReactComponent };